import ContactIconHome from '../components/contactIconHome'
import styles from './home.module.css'
import LogoContainer from './logoContainer'
import CareTextImage from '../assets/text.png'

const ContactUs = () => {
  return (
    <div className={styles.contactUsContainer}>
      <ContactIconHome className={styles.contactIcon} />
      <div className={styles.contactUsText}>未成年人消费/发票处理电话:</div>
      <div className={styles.contactUsPhone}>400-6501866</div>
      <div className={styles.contactUsTime}>(每天9:00-18:00)</div>
    </div>
  )
}

const CareText = () => {
  return (
    <div className={styles.careTextContainer}>
      <div className={styles.careText1}>
        <img src={CareTextImage} alt='' className={styles.careTextImage} />
      </div>
      <div className={styles.careText2}>
        陪伴青少年健康成长
      </div>
    </div>
  )
}

export default () => {
  return (
    <div className={styles.scene0}>
      <LogoContainer />
      <ContactUs />
      <CareText />
      <div className={styles.footer}>
        <div className={styles.web}>
          下滑查看常见问题
        </div>
      </div>
    </div>
  )
}